import { Http } from "@/plugins/http.js";

export default {
  namespaced: true,

  state: {
    /** @type {number|null} id Хранит ИД доктора */
    id: null,
    profile: null,
    accessToken: "",
    dashboards: [],
  },

  getters: {
    getUserId: state => state.profile.id,
  },

  actions: {
    async login({ commit }, form) {
      try {
        const { data } = await Http.post(`auth/login`, form);

        if (data.success) {
          const token = `Bearer ${data.token}`;

          localStorage.setItem("accessToken", token);
          commit("SET_ACCESS_TOKEN", token);
          commit("SET_PROFILE", data.data);
          commit("SET_ID", data.data.id);

          return { success: true };
        }

        return { success: false, message: data.message };
      } catch (e) {
        console.log("err", e);
      }

      return { success: false, message: "Что-то пошло не так:-( Свяжитесь с администрацией." };
    },

    loadToken({ commit }) {
      const token = localStorage.getItem("accessToken");
      if (token) {
        commit("SET_ACCESS_TOKEN", token);
      }
    },

    async loadProfile({ commit, state }) {
      if (state.profile !== null) {
        return;
      }

      // Если токена нету, то профиль получить не получится
      if (state.accessToken === "") {
        return;
      }

      try {
        const { data } = await Http.get(`core-auth`, {
          headers: { Authorization: state.accessToken },
        });

        if (data.success) {
          commit("SET_PROFILE", data.data);
          commit("SET_ID", data.data.id);
        }
      } catch (e) {
        commit("CLEAR_AUTH");
        console.log("err", e);
      }
    },

    async loadByHash(store, { hash, redirect }) {
      console.log(`store =>`, store);
      try {
        console.info("loadByHash", hash);
        const { data } = await Http.post(`auth/login-hash`, { hash });

        if (data.success) {
          if (redirect) {
            const newPath = `?customer_id=${store.state.customer.id}&doctor_id=${data.data.id}#/ikp`;
            const domain = window.location.href.split("?")[0];
            window.location.href = domain + newPath;
          } else {
            const token = `Bearer ${data.token}`;

            localStorage.setItem("accessToken", token);
            store.commit("SET_ACCESS_TOKEN", token);
            store.commit("SET_PROFILE", data.data);
          }
        } else {
          console.log("HASH не корректный");
        }
      } catch (e) {
        //
      }
    },
  },

  mutations: {
    SET_ID(state, id) {
      state.id = +id;
    },

    SET_ACCESS_TOKEN(state, token) {
      state.accessToken = token;
    },

    SET_PROFILE(state, profile) {
      state.profile = profile;
    },

    CLEAR_AUTH(state) {
      state.profile = null;
      state.accessToken = "";
      state.dashboards = [];
      localStorage.removeItem("accessToken");
    },

    SET_DASHBOARDS(state, dashboards) {
      state.dashboards = dashboards;
    },
  },
};
